import { render, staticRenderFns } from "./Recall.vue?vue&type=template&id=1aa7dc36&"
import script from "./Recall.vue?vue&type=script&lang=js&"
export * from "./Recall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports